import { PatientStatus } from "@prisma/client";

export type specialityOption = {
  value: string;
  label: string;
};

export const SpecialityOptions: Array<specialityOption> = [
  { value: "cosmetic", label: "Cosmetic Dentistry" },
  { value: "hygienist", label: "Dental Hygienist" },
  { value: "implant", label: "Dental Implants" },
  { value: "labor", label: "Dental Laboratory Technician" },
  { value: "dentistry", label: "Dentistry" },
  { value: "diabetics", label: "Dentistry For Diabetics" },
  { value: "denturist", label: "Denturist" },
  { value: "dermatology", label: "Dermatology" },
  { value: "endodontics", label: "Endodontics" },
  { value: "general", label: "General Dentistry" },
  { value: "orthodontics", label: "Orthodontics" },
  { value: "pediatric", label: "Pediatric Dentistry" },
  { value: "perio", label: "Periodontology" },
  { value: "prostho", label: "Prosthodontics" },
  { value: "sleep", label: "Sleep Dentistry" },
];

export const PatientStatusOptions = [
  { value: PatientStatus.NEW, label: "New Patient" },
  { value: PatientStatus.RETURNING, label: "Returning Patient" },
];

export const AppointmentOptions = [
  { value: 0, label: "All Appointments" },
  { value: 1, label: "Online Booked" },
  { value: 2, label: "Internal Appointment" },
];

export const DateRangeOptions = [
  { value: 0, label: "Month to Date" },
  { value: 1, label: "Today" },
  { value: 2, label: "Past 7 Days" },
  { value: 3, label: "Last Month" },
];

type paymentOption = {
  paymentType: string;
  label: string;
  value: string;
};

export const PaymentOptions: Array<paymentOption> = [
  { value: "aetna", label: "Aetna", paymentType: "insurance" },
  { value: "aflac", label: "AFLAC", paymentType: "insurance" },
  { value: "alaska", label: "Alaska Carpenters**", paymentType: "insurance" },
  { value: "amc", label: "Allied Metal Crafts", paymentType: "insurance" },
  { value: "always", label: "ALWAYS CARE BENEFITS", paymentType: "insurance" },
  { value: "ameriben", label: "AmeriBen", paymentType: "insurance" },
  { value: "achp", label: "America's Choice Health Plan", paymentType: "insurance" },
  { value: "ameritas", label: "Ameritas", paymentType: "insurance" },
  { value: "anthem", label: "Anthem BCBS", paymentType: "insurance" },
  { value: "apwu", label: "APWU HEALTH PLAN", paymentType: "insurance" },
  { value: "assurant", label: "Assurant health", paymentType: "insurance" },
  { value: "avesis", label: "Avesis", paymentType: "insurance" },
  { value: "axis", label: "AXIS INSURANCE COMPANY", paymentType: "insurance" },
  { value: "bcbs", label: "BCBS", paymentType: "insurance" },
  { value: "beam", label: "Beam Dental", paymentType: "insurance" },
  { value: "bas", label: "Benefit Administrative Systems, LLC", paymentType: "insurance" },
  { value: "benefit", label: "BENEFIT SOLUTIONS", paymentType: "insurance" },
  { value: "best", label: "BEST LIFE", paymentType: "insurance" },
  { value: "carrington", label: "Carrington plan", paymentType: "insurance" },
  { value: "cas", label: "CAS (Coastal Administrative Services)", paymentType: "insurance" },
  { value: "cherokee", label: "Cherokee Insurance", paymentType: "insurance" },
  { value: "chesapeake", label: "CHESAPEAKE", paymentType: "insurance" },
  { value: "cigna", label: "Cigna", paymentType: "insurance" },
  { value: "delta", label: "Delta Dental", paymentType: "insurance" },
  { value: "select", label: "DENTAL SELECT", paymentType: "insurance" },
  { value: "dentegra", label: "Dentegra", paymentType: "insurance" },
  { value: "fce", label: "FCE Benefit Administrator", paymentType: "insurance" },
  { value: "fep", label: "FEP BLUE DENTAL", paymentType: "insurance" },
  { value: "first", label: "First Choice", paymentType: "insurance" },
  { value: "gena", label: "GEHA", paymentType: "insurance" },
  { value: "group", label: "Group Health", paymentType: "insurance" },
  { value: "guardian", label: "Guardian", paymentType: "insurance" },
  { value: "welfare", label: "Health & Welfare Plan", paymentType: "insurance" },
  { value: "hca", label: "HEALTH COMP ADMINISTRATORS", paymentType: "insurance" },
  { value: "hpartner", label: "HEALTH PARTNERS", paymentType: "insurance" },
  { value: "hplex", label: "HEALTH PLEX", paymentType: "insurance" },
  { value: "hma", label: "HMA Dental", paymentType: "insurance" },
  { value: "hmsa", label: "HMSA", paymentType: "insurance" },
  { value: "humana", label: "HUMANA", paymentType: "insurance" },
  { value: "ihc", label: "IHC HEALTH SOLUTIONS", paymentType: "insurance" },
  { value: "ilwu", label: "ILWU-PMA Benefit Plans Office", paymentType: "insurance" },
  { value: "iaic", label: "Independence American Insurance Company", paymentType: "insurance" },
  { value: "kaiser", label: "Kaiser Permanente", paymentType: "insurance" },
  { value: "kansas", label: "KANSAS CITY LIFE- HEALTHY CHOICES", paymentType: "insurance" },
  { value: "kps", label: "KPS Health Care", paymentType: "insurance" },
  { value: "liberty", label: "Liberty", paymentType: "insurance" },
  { value: "life", label: "LIFE MAP", paymentType: "insurance" },
  { value: "lifewise", label: "LIFEWISE", paymentType: "insurance" },
  { value: "lincoln", label: "Lincoln Financial", paymentType: "insurance" },
  { value: "line", label: "LineCo.", paymentType: "insurance" },
  { value: "metlife", label: "Metlife", paymentType: "insurance" },
  { value: "mutual", label: "Mutual of Omaha", paymentType: "insurance" },
  { value: "national", label: "National General", paymentType: "insurance" },
  { value: "neihb", label: "NEIHB Fund Office", paymentType: "insurance" },
  { value: "nippon", label: "Nippon Life Benefits", paymentType: "insurance" },
  { value: "nwadmin", label: "NORTHWEST ADMINISTRATORS", paymentType: "insurance" },
  { value: "nwiron", label: "NORTHWEST IRON WORKERS", paymentType: "insurance" },
  { value: "nwmetal", label: "Northwest Metal Crafts Trust Fund", paymentType: "insurance" },
  { value: "nwiam", label: "NW IAM", paymentType: "insurance" },
  { value: "planned", label: "Planned Administrators, Inc.", paymentType: "insurance" },
  { value: "premera", label: "PREMERA", paymentType: "insurance" },
  { value: "principal", label: "PRINCIPAL", paymentType: "insurance" },
  { value: "providence", label: "Providence Health Plan", paymentType: "insurance" },
  { value: "psew", label: "Puget Sound Electrical Workers Trust Fund", paymentType: "insurance" },
  { value: "pshc", label: "Puget Sound Health Care System", paymentType: "insurance" },
  { value: "regence", label: "REGENCE", paymentType: "insurance" },
  { value: "reliance", label: "Reliance Standard", paymentType: "insurance" },
  { value: "li", label: "L&I", paymentType: "insurance" },
  { value: "sun", label: "Sun Life Financial", paymentType: "insurance" },
  { value: "chickasaw", label: "The Chickasaw Nation Tribal Health", paymentType: "insurance" },
  { value: "standard", label: "The Standard Insurance", paymentType: "insurance" },
  { value: "tpsc", label: "TPSC", paymentType: "insurance" },
  { value: "tricare", label: "Tricare", paymentType: "insurance" },
  { value: "retiree", label: "Tricare Retiree Dental Program", paymentType: "insurance" },
  { value: "triwest", label: "Triwest/DD of CA", paymentType: "insurance" },
  { value: "trusted", label: "Trusteed Plans Service Co", paymentType: "insurance" },
  { value: "umr", label: "UMR", paymentType: "insurance" },
  { value: "concordia", label: "United Concordia", paymentType: "insurance" },
  { value: "empolye", label: "United Employees Benefit Trust", paymentType: "insurance" },
  { value: "health", label: "United Healthcare", paymentType: "insurance" },
  { value: "omaha", label: "United of Omaha", paymentType: "insurance" },
  { value: "unum", label: "UNUM DENTAL", paymentType: "insurance" },
  { value: "welfare", label: "WELFARE AND PENSION ADMINISTRATION", paymentType: "insurance" },
  { value: "zenith", label: "ZENITH", paymentType: "insurance" },
  { value: "zaal", label: "Zenith American/Area Local 52", paymentType: "insurance" },
  { value: "stripe", label: "Stripe", paymentType: "direct" },
  { value: "self", label: "I will pay myself", paymentType: "direct" },
];

export type AppointmentCategory = {
  id: number;
  name: string;
  types: Array<AppointmentSubCategory>;
};

export type AppointmentSubCategory = {
  id: number;
  name: string;
  types: Array<AppointmentType>;
};

export type AppointmentType = {
  id: number;
  name: string;
  description?: string;
  isMultiple: boolean;
  times: Array<AppointmentTime>;
};

export type AppointmentTime = {
  provider: string;
  preAssistTime: number;
  providerTime: number;
  postAssistTime: number;
  multipleTime?: Array<number>;
};

export const AppointmentTypes: Array<AppointmentCategory> = [
  {
    id: 1,
    name: "Doctor",
    types: [
      {
        id: 11,
        name: "RESTORATIVE",
        types: [
          {
            id: 1101,
            name: "O,L,B,F,I Filling",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 5,
                postAssistTime: 10,
                multipleTime: [0, 5, 10],
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 5,
                postAssistTime: 10,
                multipleTime: [0, 5, 10],
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 5,
                postAssistTime: 10,
                multipleTime: [0, 5, 10],
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 5,
                postAssistTime: 10,
                multipleTime: [0, 5, 10],
              },
            ],
          },
          {
            id: 1102,
            name: "M,D Filling",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 15,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 10,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 15,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 15,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
            ],
          },
          {
            id: 1103,
            name: "Prep 1 Crown, BU",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 20,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1104,
            name: "Prep 2 Crowns, BU",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 40,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 20,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 50,
                postAssistTime: 40,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 40,
              },
            ],
          },
          {
            id: 1105,
            name: "Add Crown, BU",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 20, 10],
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 10, 10],
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 10, 10],
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 20, 10],
              },
            ],
          },
          {
            id: 1106,
            name: "Prep Bridge 3 unit",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 40,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 20,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 40,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 40,
              },
            ],
          },
          {
            id: 1107,
            name: "Add Abutment",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 20, 10],
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 10, 10],
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 10, 10],
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [0, 20, 10],
              },
            ],
          },
          {
            id: 1108,
            name: "Deliver 1 Crown",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1109,
            name: "Deliver 2 Crowns",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 30,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 40,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 40,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 20,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1110,
            name: "Deliver Crown",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [10, 10, 0],
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [10, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [10, 10, 0],
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 0,
                postAssistTime: 0,
                multipleTime: [10, 10, 0],
              },
            ],
          },
          {
            id: 1111,
            name: "Deliver Bridge",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1112,
            name: "Pulp/SSC",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 10,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
                multipleTime: [0, 20, 10],
              },
            ],
          },
        ],
      },
      {
        id: 12,
        name: "ROOT CANALS",
        types: [
          {
            id: 1201,
            name: "Anterior RCT/BU",
            description: "All done in 1 appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 70,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 70,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 1202,
            name: "Anterior RCT/BU",
            description: "2 stage - 1st appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1203,
            name: "Anterior RCT/BU",
            description: "Finish RCT - 2nd appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1204,
            name: "Premolar RCT/BU",
            description: "All done in 1 appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 90,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 90,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 1205,
            name: "Premolar RCT/BU",
            description: "2 stage - 1st appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 1206,
            name: "Premolar RCT/BU",
            description: "Finish RCT - 2nd appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1207,
            name: "Molar RCT/BU",
            description: "All done in 1 appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 110,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 50,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 100,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1208,
            name: "Molar RCT/BU",
            description: "2 stage - 1st appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 70,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1209,
            name: "Molar RCT/BU",
            description: "Finish RCT - 2nd appt",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1210,
            name: "Pulp Therapy Debrid",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 50,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 50,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 50,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
      {
        id: 13,
        name: "EXTRACTIONS",
        types: [
          {
            id: 1301,
            name: "EXT CorRemn",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
            ],
          },
          {
            id: 1302,
            name: "EXT Simple",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
              {
                provider: "newton",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
            ],
          },
          {
            id: 1303,
            name: "EXT Surgical",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 10, 0],
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
              {
                provider: "newton",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
                multipleTime: [0, 20, 0],
              },
            ],
          },
          {
            id: 1304,
            name: "EXT Wisdom",
            isMultiple: true,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 20,
                multipleTime: [0, 20, 0],
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 20,
                multipleTime: [0, 15, 0],
              },
            ],
          },
        ],
      },
      {
        id: 14,
        name: "SEDATION",
        types: [
          {
            id: 1401,
            name: "IV Sedation",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 0,
                postAssistTime: 30,
              },
            ],
          },
          {
            id: 1402,
            name: "Oral Sedation",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 60,
                providerTime: 0,
                postAssistTime: 30,
              },
              {
                provider: "leung",
                preAssistTime: 60,
                providerTime: 0,
                postAssistTime: 30,
              },
              {
                provider: "kern",
                preAssistTime: 60,
                providerTime: 0,
                postAssistTime: 30,
              },
            ],
          },
          {
            id: 1403,
            name: "N2O",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 20,
                providerTime: 0,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 15,
        name: "IMPLANTS",
        types: [
          {
            id: 1501,
            name: "Implant",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1502,
            name: "Bonegraft",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1503,
            name: "2nd Stage",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 30,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1504,
            name: "Crown Impression",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 20,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 20,
              },
              {
                provider: "newton",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1505,
            name: "Post Op",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
      {
        id: 16,
        name: "MISCELLANEOUS",
        types: [
          {
            id: 1601,
            name: "Frenectomy",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1602,
            name: "Gingivectomy",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 1603,
            name: "Crown Lengthing",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 20,
              },
            ],
          },
        ],
      },
      {
        id: 17,
        name: "DENTURES",
        types: [
          {
            id: 1701,
            name: "Denture 1 - Records",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1702,
            name: "Denture 2 - Bite",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 20,
                providerTime: 30,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1703,
            name: "Denture 3 - Try In",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1704,
            name: "Denture 4 - Deliver",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 30,
                providerTime: 10,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 1705,
            name: "Denture 5 - Adjust",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "leung",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "kern",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
              {
                provider: "newton",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 18,
        name: "NIGHTGUARDS",
        types: [
          {
            id: 1801,
            name: "Nightguard Impress",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 1802,
            name: "Nightguard Deliver",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
              {
                provider: "leung",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
              {
                provider: "kern",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
              {
                provider: "newton",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 2,
    name: "Hygiene",
    types: [
      {
        id: 21,
        name: "New Patients",
        types: [
          {
            id: 2101,
            name: "NP Adult 18+",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 50,
                postAssistTime: 20,
              },
            ],
          },
          {
            id: 2102,
            name: "NP Teen 12-17",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2103,
            name: "NP Tween 4-11",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2104,
            name: "NP Child 0-3",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
      {
        id: 22,
        name: "Recall",
        types: [
          {
            id: 2201,
            name: "Recall Adult",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2202,
            name: "Recall Maint",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2203,
            name: "Recall Teen",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2204,
            name: "Recall Child",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2205,
            name: "Perio Re-Eval",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 23,
        name: "Emergency",
        types: [
          {
            id: 2301,
            name: "Limited Exam",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 60,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 2302,
            name: "Consult",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 60,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 2303,
            name: "Sealants (HYG)",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 24,
        name: "Scaling / Root Planing (1-3)",
        types: [
          {
            id: 2401,
            name: "SCRP (1) 1-3",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2402,
            name: "SCRP (2) 1-3",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 40,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2403,
            name: "SCRP (3) 1-3",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2404,
            name: "SCRP (4) 1-3",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 25,
        name: "Scaling / Root Planing (Quad) - LIGHT",
        types: [
          {
            id: 2501,
            name: "SCRP (1) Quad",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2502,
            name: "SCRP (2) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2503,
            name: "SCRP (3) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2504,
            name: "SCRP (4) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 100,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 26,
        name: "Scaling / Root Planing (Quad) - MODERATE",
        types: [
          {
            id: 2601,
            name: "SCRP (1) Quad",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2602,
            name: "SCRP (2) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2603,
            name: "SCRP (3) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2604,
            name: "SCRP (4) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 100,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 27,
        name: "Scaling / Root Planing (Quad) - HEAVY",
        types: [
          {
            id: 2701,
            name: "SCRP (1) Quad",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 30,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2702,
            name: "SCRP (2) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 60,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2703,
            name: "SCRP (3) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 80,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2704,
            name: "SCRP (4) Quads",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 100,
                postAssistTime: 10,
              },
            ],
          },
        ],
      },
      {
        id: 28,
        name: "Other",
        types: [
          {
            id: 2801,
            name: "Sealants (HYG)",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 2802,
            name: "Whitening Records",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 2803,
            name: "Whitening Deliver",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 2804,
            name: "InOffice Whitening",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 120,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    name: "Ortho",
    types: [
      {
        id: 31,
        name: "Ortho",
        types: [
          {
            id: 301,
            name: "Consult",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 60,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 302,
            name: "Records",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 50,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 303,
            name: "Initial Bracketing",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 50,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 304,
            name: "Initial Invisalign",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 50,
                providerTime: 20,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 305,
            name: "Periodic",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 10,
                providerTime: 10,
                postAssistTime: 40,
              },
            ],
          },
          {
            id: 306,
            name: "Ortho Emergency",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 50,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 307,
            name: "Ortho Debond",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 20,
                providerTime: 10,
                postAssistTime: 30,
              },
            ],
          },
          {
            id: 308,
            name: "Retainer Impress",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 30,
                postAssistTime: 0,
              },
            ],
          },
          {
            id: 309,
            name: "Del Bond Retainer",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 40,
                providerTime: 10,
                postAssistTime: 10,
              },
            ],
          },
          {
            id: 310,
            name: "Del Retainer",
            isMultiple: false,
            times: [
              {
                provider: "default",
                preAssistTime: 0,
                providerTime: 20,
                postAssistTime: 0,
              },
            ],
          },
        ],
      },
    ],
  },
];
